import React, { useEffect, useState } from 'react'
import { setCurrentCategory } from '../../reducers/product.reducer'
import { generatePublicUrl } from '../../urlConfig'

const CategoryList = ({
    editChildrenCategoryIndex,
    category = [],
    slideIndex,
}) => {
    const [mainCategoryId, setMainCategoryId] = useState(null)

    useEffect(() => {
        if (!category.length) {
            setMainCategoryId(null)
            return
        }

        const currentStillExists = category.some((item) => item._id === mainCategoryId)

        if (!currentStillExists) {
            setMainCategoryId(category[0]._id)
        }
    }, [category, mainCategoryId])

    const currentCategory = (obj) => {
        setCurrentCategory(obj._id)
        setMainCategoryId(obj._id)
    }

    return (
        <div className="productList productList--categoryBrowser">
            <div className="productList__containerMainCategory">
                {category.map((obj) => (
                    <button
                        type="button"
                        key={obj._id || obj.slug || obj.name}
                        onClick={() => currentCategory(obj)}
                        className={
                            mainCategoryId === obj._id
                                ? 'productList__mainCategory active'
                                : 'productList__mainCategory'
                        }
                    >
                        {obj.name}
                    </button>
                ))}
            </div>

            <div className="productList__container">
                <div className="productList__mainItemBox">
                    {category.map((obj) => (
                        <div
                            key={obj._id || obj.slug || obj.name}
                            className="productList__categoryMainContainer"
                        >
                            <div
                                className={
                                    mainCategoryId === obj._id
                                        ? 'productList__categoryItemContainer active'
                                        : 'productList__categoryItemContainer'
                                }
                            >
                                {(obj.children || []).map((childrenCategory, index) => (
                                    <button
                                        type="button"
                                        key={childrenCategory._id || childrenCategory.slug || childrenCategory.name}
                                        onClick={() => editChildrenCategoryIndex(childrenCategory)}
                                        className={
                                            slideIndex === index + 1
                                                ? 'productList__categoryItemBox active'
                                                : 'productList__categoryItemBox'
                                        }
                                        title={childrenCategory.name}
                                    >
                                        <span className="productList__imgContainer" aria-hidden="true">
                                            {childrenCategory.categoryImage ? (
                                                <img
                                                    src={generatePublicUrl(childrenCategory.categoryImage)}
                                                    alt=""
                                                    loading="lazy"
                                                />
                                            ) : (
                                                <span className="productList__imgFallback">
                                                    {String(childrenCategory.name || '?').trim().charAt(0).toUpperCase()}
                                                </span>
                                            )}
                                        </span>

                                        <span className="productList__text">
                                            {childrenCategory.name}
                                        </span>
                                    </button>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default CategoryList
